import { render } from "./milestone-form.vue?vue&type=template&id=510d9101&scoped=true&ts=true"
import script from "./milestone-form.vue?vue&type=script&lang=ts"
export * from "./milestone-form.vue?vue&type=script&lang=ts"

import "./milestone-form.vue?vue&type=style&index=0&id=510d9101&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510d9101"]])

export default __exports__